<script lang="ts">
    import { users } from "../../../store"

    export let task: Task
    const assignedIds = task.meta.assignedUsers || []
    $: assignedUsers = assignedIds.map((id) => $users[id]?.username)
</script>

{#if assignedIds.length === 0}
    <p>
        Niemand wurde zugewiesen. Jeder mit entsprechenden Berechtigungen sollte sich vergewissern, ob er diesen Einsatz
        umsetzen soll.
    </p>
{:else}
    <ul class="assigned-people">
        {#each assignedUsers as user}
            <li>
                <p>{user}</p>
            </li>
        {/each}
    </ul>
{/if}

<style>
    p {
        white-space: normal;
    }
    .assigned-people {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        gap: 0.5rem;
    }

    .assigned-people li {
        background-color: var(--color-gray-200);
        border-radius: 0.5rem;
    }
</style>
